import { useState, useEffect } from "react";
import logo from '../../img/logo.png';
import clienteAxios from "../../axios";
import Cargador from "../../componentes/Cargador";

const PremioGanador = () => {
    const queryParameters = new URLSearchParams(window.location.search);
    const Id = queryParameters.get("id");
    const [premio, setPremio] = useState(null);
    const [cargador, setCargador] = useState(true);
    const [respuesta, setRespuesta] = useState(null);
    
    useEffect(() => {
        if (Id) {
            consultarPremio();
        }       
    }, []);


    const consultarPremio = async () => {

        const config = {
            "Content-Type": "application/json",
            "Authorization": `Bearer ${localStorage.getItem("token")}`
        }
        const data = {
            "sp": "respuestas",
            "op": "premio",
            "Id": Id
        }

        try {
            setCargador(true);            
            const result = await clienteAxios.post("/api/sp", data, config);            
            setPremio(result.data.data[0][0]);        
            let datos=JSON.parse(result.data.data[0][0].respuesta)
            setRespuesta(datos.data);
        } catch (error) {
            console.error("Error al consultar premios:", error);
        } finally {
            setCargador(false);
        }
    };

    return (
        <>
            <div className="min-h-full">
                <div className="bg-black pb-32">
                    <header className="py-5">
                        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
                            <img
                                src={logo}
                                alt="Encuesta Parque Monchis"
                                className="w-80 h-23 mx-auto"
                            />
                        </div>
                    </header>
                </div>

                <main className="-mt-32">
                    <div className="mx-auto max-w-7xl px-4 pb-12 sm:px-6 lg:px-8">
                        <div className="rounded-lg bg-white px-5 py-6 shadow sm:px-6 sm:w-full md:w-1/2 overflow-hidden min-h-screen m-auto">
                            <h2 className="text-3xl font-bold text-center mb-6 mt-4">Premio Ganador</h2>
                            <div className="text-center space-y-2" >
                                {premio ? (
                                    <>
                                        <p className="text-lg text-center p-4">
                                            ¡Felicidades! Has ganado un premio! <br/><strong>{premio.premio}</strong>
                                        </p>
                                        <div className="w-1/2 m-auto">
                                            <hr/>
                                                <img src={premio.imagen} className="w-full" alt="Premio"  />
                                            <hr/>
                                        </div>
                                        <p>
                                            Registrado al correo: <strong>{premio.correo}</strong>
                                        </p>
                                        <p>fecha de registro: <strong className="text-blue-500">{premio.createAd.split("T")[0]} {premio.createAd.split("T")[1].split(".")[0]}</strong></p>
                                        <p>
                                            Tu premio es valido por 30 días de martes a viernes
                                        </p>
                                        <hr className="p-4"/>

                                        <ul>
                                            {respuesta.map((item, index) => (
                                                <li key={index}>
                                                    <p className="text-left w-full pt-4 text-blue-600">{item.Pregunta1}</p>
                                                    <p className="text-left font-bold w-full">{item.respuesta}</p>
                                                </li>
                                            ))}
                                        </ul>
                                        <ul className="text-left text-sm mt-4 p-4 text-gray-400 my-4 space-y-1">
                                            <li><strong>Condiciones</strong></li>
                                            <li>Válido para el titular de este correo.</li>
                                            <li>Un premio por cuenta/cliente. No acumulable con otras promociones.</li>
                                            <li>Sujeto a disponibilidad y a cambios sin previo aviso.</li>
                                            <li>Debes presentar una identificación si se solicita.</li>                                        
                                        </ul>
                                    </>
                                ) : (
                                    <p className="text-lg text-center">
                                        No se encontró ningún premio para el folio.
                                    </p>
                                )}
                            </div>
                        </div>
                    </div>
                </main>
            </div>
        </>
    )
}
export default PremioGanador;